import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const FREQUENCY_OPTIONS = [
  { value: "weekly", label: "1 fois par semaine", short: "Semaine" },
  { value: "monthly", label: "1 fois par mois", short: "Mois" },
  { value: "yearly", label: "1 fois par an", short: "Année" },
];

export default function NewsletterForm({ variant = "band" }) {
  const [email, setEmail] = useState("");
  const [frequency, setFrequency] = useState("monthly");
  const [loading, setLoading] = useState(false);
  const isFooter = variant === "footer";
  const prefix = isFooter ? "footer-newsletter" : "newsletter";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email: email.trim(), frequency });
      if (data.status === "already") {
        toast.info(data.message);
      } else {
        toast.success(data.message);
      }
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Une erreur est survenue, réessayez dans un instant.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <form data-testid={`${prefix}-form`} onSubmit={handleSubmit} className="flex w-full gap-2">
        <input
          data-testid={`${prefix}-email`}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Votre adresse e-mail"
          className={`min-w-0 flex-1 rounded-full border px-5 py-3 text-sm outline-none transition-colors focus:border-amber-deep ${
            isFooter
              ? "border-cream/20 bg-cream/10 text-cream placeholder:text-cream/40"
              : "border-amber-900/20 bg-white text-bark placeholder:text-stone-mute"
          }`}
        />
        <button
          data-testid={`${prefix}-submit`}
          type="submit"
          disabled={loading}
          className="flex items-center gap-2 rounded-full bg-amber-deep px-5 py-3 text-sm font-medium text-white shadow-md shadow-amber-900/10 transition-all duration-200 hover:bg-honey active:scale-95 disabled:opacity-60"
        >
          {loading ? "Envoi…" : isFooter ? <ArrowRight size={16} /> : "S'abonner"}
        </button>
      </form>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <span className={`text-xs ${isFooter ? "text-cream/50" : "text-stone-mute"}`}>Recevoir la Gazette :</span>
        {FREQUENCY_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            data-testid={`${prefix}-frequency-${opt.value}`}
            onClick={() => setFrequency(opt.value)}
            title={opt.label}
            className={`rounded-full px-3 py-1 text-xs font-medium transition-all duration-200 ${
              frequency === opt.value
                ? "bg-amber-deep text-white shadow-sm"
                : isFooter
                  ? "border border-cream/25 text-cream/70 hover:border-cream/50 hover:text-cream"
                  : "border border-amber-900/20 text-bark-soft hover:border-amber-deep hover:text-amber-deep"
            }`}
          >
            {opt.short}
          </button>
        ))}
      </div>
    </div>
  );
}
